import React from 'react'

 const LoaderScreen=()=>{
    return (
        <div className="row" id="preloader">
        <div className="col-12 col-lg-12 loader-margin text-center">
          <div className="a-loading a-primary a-m-10">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    )
}

export default LoaderScreen